import { Component, OnInit, Input } from '@angular/core';

@Component({
  selector: 'app-icon-singsnap',
  templateUrl: './icon-singsnap.component.html',
  styleUrls: ['./icon-singsnap.component.scss']
})
export class IconSingsnapComponent implements OnInit {
  @Input() color: string = 'rgb(208, 208, 208)';
  @Input() size: number = 18;

  constructor() { }

  ngOnInit() {
  }

}
